// extracted by mini-css-extract-plugin
export default {"text":"PromptModal_text__jdybc","buttons":"PromptModal_buttons__ujbGV"};